import { render, staticRenderFns } from "./FormThresholdSection.vue?vue&type=template&id=1f0f163b&"
import script from "./FormThresholdSection.vue?vue&type=script&lang=js&"
export * from "./FormThresholdSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports